// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3lGYn","footer":"ModalUpdate_footer__1xrKI"};